import { useState, memo, Fragment, useRef } from 'react';
import { IEveryoneIsAsk } from '..';
import { getGlobalStore } from '@/store/global';
import { EveryoneIsAskItemIconSvg, DownwardSvg, ReplaceEveryoneIsAskSvg } from '@/components/svg-icons/qa-records';
import { IEveryoneIsAskItemInOcr } from '@/types';
import AnimationContainer from '@/components/animation-container';
import { useDebounceFn } from 'ahooks';
import classNames from 'classnames';
import './index.scss';
import { getQaStore } from '@/store/qa';
import { query_everyone_is_asks } from '@/apis/qa';

const EveryoneIsAsk = ({ asks, hasNextPage }: Pick<IEveryoneIsAsk, 'asks' | 'hasNextPage'>) => {
    const pageInfo = useRef({ pageNum: 1, pageSize: 3 });
    const noNextPage = useRef(!hasNextPage);
    const [open, setOpen] = useState<boolean | undefined>(() => (asks.length <= 3 ? undefined : false));
    const [animation, setAnimation] = useState(false);
    const [everyoneIsAsks, setEveryoneIsAsks] = useState<IEveryoneIsAskItemInOcr[]>(asks);

    const handleViewDetail = (askId: number) => {
        getGlobalStore()?.publish('QuestionDetailDrawer', { type: 'show', askId });
    };

    const handleInputFocus = () => {
        getGlobalStore()?.publish('DialogueTool', { type: 'focus' });
    };

    const { run: handleReplaceEveryoneIsAsk } = useDebounceFn(
        async () => {
            setAnimation(true);
            setTimeout(() => setAnimation(false), 300);
            if (noNextPage.current) {
                getGlobalStore()!.publish('Toast', { type: 'show', message: '没有更多了' });
                return;
            }
            pageInfo.current.pageNum++;
            const { resourceType, resourceId } = getQaStore()!.qaConfig!;
            const { result } = await query_everyone_is_asks({
                resourceType: resourceType!,
                resourceId: resourceId!,
                ...pageInfo.current,
            });
            const { list = [] } = result || {};
            noNextPage.current = list.length < 3;
            if (list.length > 0) {
                setEveryoneIsAsks(list);
            } else {
                getGlobalStore()!.publish('Toast', { type: 'show', message: '没有更多了' });
            }
        },
        { wait: 500 }
    );

    return (
        <AnimationContainer className="respondent-container" type="enter_from_the_left">
            <div className="everyone-is-ask">
                <div className="ocr-everyone-is-ask__header">
                    <div className="everyone-is-ask__title">大家都在问</div>
                    {asks.length > 0 && (
                        <div className="ocr-everyone-is-ask__replace" onClick={handleReplaceEveryoneIsAsk}>
                            <ReplaceEveryoneIsAskSvg
                                className={classNames('ocr-everyone-is-ask__icon', animation && 'ocr-everyone-is-ask__icon--animation')}
                            />
                            <span>换一换</span>
                        </div>
                    )}
                </div>
                {everyoneIsAsks.length ? (
                    everyoneIsAsks.map(item => (
                        <Fragment key={item.askId}>
                            <div className="everyone-is-ask__item" onClick={() => handleViewDetail(item.askId)}>
                                <EveryoneIsAskItemIconSvg className="everyone-is-ask__item-icon" />
                                <span className="everyone-is-ask__content">{item.content}</span>
                            </div>
                        </Fragment>
                    ))
                ) : (
                    <img
                        className="everyone-is-ask__no-data"
                        src="https://simg01.gaodunwangxiao.com/uploadfiles/files/202501/15/9a0a9_20250115102104.png"
                        onClick={handleInputFocus}
                    />
                )}
                {open === false && (
                    <div className="everyone-is-ask__view-more" onClick={() => setOpen(true)}>
                        <span>查看更多</span>
                        <DownwardSvg className="everyone-is-ask__view-more-icon" />
                    </div>
                )}
                {open === true && (
                    <div className="everyone-is-ask__put-away" onClick={() => setOpen(false)}>
                        <span>收起</span>
                        <DownwardSvg className="everyone-is-ask__put-away-icon" />
                    </div>
                )}
            </div>
        </AnimationContainer>
    );
};

export default memo(EveryoneIsAsk);
